import { ChartEventLabels, ChartEventType } from '../constants/common'
import ChartEvent from './chart-event'

class Dividends extends ChartEvent {
  static type = ChartEventType.Dividends
  static label = ChartEventLabels[ChartEventType.Dividends]
}

export default Dividends
